import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Collapse, createStyles, IconButton } from '@material-ui/core';
import { Alert as MUIAlert, AlertTitle as MUIAlertTitle } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
import { CheckCircle, Close, Info, Warning, Error } from '@material-ui/icons';
var useStyles = makeStyles(function (theme) {
  return createStyles({
    root: {
      color: theme.palette.background.default
    }
  });
});
var iconMap = {
  success: /*#__PURE__*/React.createElement(CheckCircle, {
    fontSize: "inherit"
  }),
  info: /*#__PURE__*/React.createElement(Info, {
    fontSize: "inherit"
  }),
  warning: /*#__PURE__*/React.createElement(Warning, {
    fontSize: "inherit"
  }),
  error: /*#__PURE__*/React.createElement(Error, {
    fontSize: "inherit"
  })
};

var Alert = function Alert(_ref) {
  var body = _ref.body,
      children = _ref.children,
      dsOnClose = _ref.dsOnClose,
      e2e = _ref.e2e,
      getBodySlot = _ref.getBodySlot,
      header = _ref.header,
      open = _ref.open,
      _ref$severity = _ref.severity,
      severity = _ref$severity === void 0 ? 'error' : _ref$severity,
      action = _ref.action,
      _ref$dismissible = _ref.dismissible,
      dismissible = _ref$dismissible === void 0 ? false : _ref$dismissible;
  var bodyCb = React.useCallback(function (node) {
    getBodySlot && getBodySlot(node);
  }, [getBodySlot]);
  var classes = useStyles();
  /* Web components progressively render. We need to wait
   * for the open value to animate properly.
   */

  if (open === undefined) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Collapse, _extends({
    in: open
  }, e2e && {
    'data-e2e': e2e
  }), /*#__PURE__*/React.createElement(MUIAlert, {
    className: classes.root,
    iconMapping: iconMap,
    severity: severity,
    action: action || dismissible && /*#__PURE__*/React.createElement(IconButton, _extends({
      color: "inherit",
      size: "small",
      "aria-label": "Close",
      title: "Close",
      onClick: dsOnClose
    }, e2e && {
      'data-e2e': "".concat(e2e, "-close")
    }), /*#__PURE__*/React.createElement(Close, null)),
    variant: "filled"
  }, /*#__PURE__*/React.createElement(MUIAlertTitle, e2e && {
    'data-e2e': "".concat(e2e, "-header")
  }, header), /*#__PURE__*/React.createElement("span", _extends({
    ref: bodyCb
  }, e2e && {
    'data-e2e': "".concat(e2e, "-body")
  }), body, children)));
};

Alert.defaultProps = {
  severity: 'error'
};
export default Alert;

try {
  Alert.__docgenInfo = {
    description: '',
    displayName: 'Alert',
    methods: [],
    props: {
      body: {
        defaultValue: null,
        description: '',
        name: 'body',
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      dsOnClose: {
        defaultValue: null,
        description: '',
        name: 'dsOnClose',
        required: false,
        type: {
          name: '(event: SyntheticEvent<Element, Event>) => void'
        }
      },
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      },
      getBodySlot: {
        defaultValue: null,
        description: '',
        name: 'getBodySlot',
        required: false,
        type: {
          name: '(elem: HTMLElement) => any'
        }
      },
      header: {
        defaultValue: null,
        description: '',
        name: 'header',
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      open: {
        defaultValue: null,
        description: '',
        name: 'open',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      dismissible: {
        defaultValue: {
          value: false
        },
        description: '',
        name: 'dismissible',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      severity: {
        defaultValue: {
          value: 'error'
        },
        description: 'The severity of the alert. This defines the color and icon used.',
        name: 'severity',
        required: false,
        type: {
          name: 'enum',
          raw: 'Color',
          value: [{
            value: '"success"'
          }, {
            value: '"info"'
          }, {
            value: '"warning"'
          }, {
            value: '"error"'
          }]
        }
      },
      action: {
        defaultValue: null,
        description: 'The action to display. It renders after the message, at the end of the alert.',
        name: 'action',
        required: false,
        type: {
          name: 'ReactNode'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map